import { i18n } from '@/app/I18n';
import { isValidationError } from '@/errors/ValidationError';
export function promoCodeErrorMessage(value, error, input) {
    if (isValidationError(error) && !input.validity.valid) {
        return input.validationMessage;
    }
    else if ('_code' in error && error._code) {
        return promoCodeApiErrorMessage(value, error);
    }
    else {
        return i18n.t('applyPromoCodes.unknownErrorMessage');
    }
}
function promoCodeApiErrorMessage(value, error) {
    const tVars = {
        code: value,
        message: error?._description,
    };
    const key = apiErrorMessageKey(error);
    return i18n.t(key, tVars);
}
function apiErrorMessageKey(error) {
    const key = `applyPromoCodes.apiErrorMessages.${error._code}`;
    if (i18n.te(key)) {
        return key;
    }
    else {
        return error._description ? 'applyPromoCodes.apiErrorMessage' : 'applyPromoCodes.defaultApiErrorMessage';
    }
}
